import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ApiCall } from '@shared/async-services/http/api-call.service';
import { BroadCastServiceService } from '@shared/services/broad-cast-service.service';
import { CommonService } from '@shared/services/common.service';
import storageService from '@shared/storage/storageService';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs/Rx';


@Component({
  selector: 'app-import-file',
  templateUrl: './import-file.component.html',
  styleUrls: ['./import-file.component.scss']
})
export class ImportFileComponent implements OnInit {

  public fileUploadScreen: any;
  width: any = 0;
  formData: FormData = new FormData();
  file: any;
  errorMsg: any;
  successMsg: any;
  loading: boolean = false;
  selectedLanguage = "";
  currentUser : any ;
  organizationData : any;
  createToaster: any;
  DEFAULT_PAGE_NO = 0;
  DEFAULT_PAGE_SIZE = 10;

  constructor(public dialog: MatDialog,
    public dialogRef: MatDialogRef<ImportFileComponent>,
    private router: Router,
    private broadCast: BroadCastServiceService,
    private apiService: ApiCall,
		public translate: TranslateService,
    private toastr: ToastrService,
    private commonService : CommonService
    ) {
  }

  ngOnInit(): void {
    this.currentUser = storageService.getItemAsJSON("currentUser");
    this.commonService.isComponent='import-file';
    this.apiService.getCurrentUser().subscribe(res =>{
      if(res){
        this.currentUser = res.data;
      }
    })
  }

  setLanguage() {
		this.selectedLanguage = storageService.getItem("language");
		this.translate.use(this.selectedLanguage);
	}

  doFileUpload() {
    let currentUrl = this.router.url;
    console.log('click on upload file==', this.fileUploadScreen);
    this.fileUploadScreen = "fileLoading";
    console.log('new valuefor  upload file==', this.fileUploadScreen);
    this.router.navigate(['Your actualComponent']);
  }

  reloadCurrentRoute() {
    let currentUrl = this.router.url;
    console.log('click on upload file==', this.fileUploadScreen);
    this.fileUploadScreen = "fileLoading";
  }

  refresh() {
    let currentUrl = this.router.url;
    this.router.navigate([currentUrl]);
  }

  runProgressBar() {
    Observable.timer(0, 100)
      .takeWhile(() =>
        this.isWidthWithinLimit()
      )
      .subscribe(() => {
        this.width = this.width + 1;
        if (this.width === 100) {
          //cong
          this.fileUploadScreen = "success";
        }
      })
  }

  isWidthWithinLimit() {
    if (this.width === 100) {
      return false;
    } else {
      return true;
    }
  }

  onSuccess(): void {
    this.width = 0;
    this.dialogRef.close(false);
    this.broadCast.sendMessage("getUser");
    this.broadCast.sendMessage('organization');
  }

  cancelUpload(): void {
    this.width = 0;
    this.dialogRef.close(false);
    this.broadCast.sendMessage("getUser");
    this.broadCast.sendMessage('organization');
  }

  onFileSelect($event: any) {
    console.log("Event : ", $event);
    this.file = $event.target.files[0];
    console.log("File : ", this.file);
    this.formData.append("file", this.file);
  }

  createUsers(): void {
    try {
      this.dialogRef.disableClose = true;
      this.loading = true;
      if(this.currentUser.roles[0].id == 1){
        this.apiService.createUsersInBulk(this.formData).subscribe((res: any) => {
          if (res.status === "SUCCESS") {
            let message = [];
            this.translate.get(['BULK_USER_CREATION_SUCCESS'])
            .subscribe(translations => {
              message = translations['BULK_USER_CREATION_SUCCESS'];
            });
            this.successMsg = message;
            this.fileUploadScreen = "success";
            this.broadCast.sendMessage("getUser");
            this.broadCast.sendMessage('organization');
            if(res.data.message === 'User limit exceed to create chief accountant'){
              this.translate.get(['USER_LIMIT_EXCEED_CA'])
              .subscribe(translations => {
                this.errorMsg = translations['USER_LIMIT_EXCEED_CA']
              })
            this.toastr.error(this.errorMsg);
            }else if(res.data.message === 'User limit exceed to create accountant'){
              this.translate.get(['USER_LIMIT_EXCEED_ACC'])
              .subscribe(translations => {
                this.errorMsg = translations['USER_LIMIT_EXCEED_ACC']
              })
            this.toastr.error(this.errorMsg);
            }else if(res.data.message === 'User limit exceed to create client'){
              this.translate.get(['USER_LIMIT_EXCEED_CLIENT'])
              .subscribe(translations => {
                this.errorMsg = translations['USER_LIMIT_EXCEED_CLIENT']
              })
            this.toastr.error(this.errorMsg);
            }
          } else if (res.status === "FAIL") {
            let message = [];
            if(res.message == 'User limit exceeds'){
              this.translate.get(['USER_LIMIT_EXCEED'])
              .subscribe(translations => {
                message = translations['USER_LIMIT_EXCEED'];
              });
            }
            if(res.data.message === 'User limit exceed to create chief accountant'){
              this.translate
              .get(["USER_LIMIT_EXCEED_CA"])
              .subscribe((translations) => {
                this.createToaster = translations["USER_LIMIT_EXCEED_CA"];
              });
            this.toastr.error(this.createToaster, "");
            }else if(res.data.message === "User limit exceed to create accountant"){
              this.translate
              .get(["USER_LIMIT_EXCEED_ACC"])
              .subscribe((translations) => {
                this.createToaster = translations["USER_LIMIT_EXCEED_ACC"];
              });
            this.toastr.error(this.createToaster, "");
            }else if(res.data.message === "You have reached the limit of 10000 for adding Client"){
              this.translate
              .get(["USER_LIMIT_EXCEED_CLIENT"])
              .subscribe((translations) => {
                this.createToaster = translations["USER_LIMIT_EXCEED_CLIENT"];
              });
            }
            else{
              this.translate.get(['BULK_USER_CREATION_FAILED'])
              .subscribe(translations => {
                message = translations['BULK_USER_CREATION_FAILED'];
              });
            }
            this.errorMsg = message;
            this.fileUploadScreen = "fail";
          }
        }, (error) => {
          console.error("Error : ", error);
        }, () => {
          this.dialogRef.disableClose = false;
          this.loading = false;
        });
      }

    } catch (error) {
      console.error("Error occurred while creating users, ", error);
    }
  }

  closePopup() {
    this.dialogRef.close();
  }
}
